import { IQueueExecutionProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";


export abstract class SchemaCoalesceService<TEntity, TJsonParsingInputType, TIQueueExecutionProp extends IQueueExecutionProp> {

    abstract coalesceParsingResultparsingResult(parsingResult: CdnSchemaJsonParsingResult<TEntity, TJsonParsingInputType>): TIQueueExecutionProp; 

}